/**
 * This is a base class for calling api
 */
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {Router} from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';





const API_CALL_TYPE = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
}


const HTTP_OPTIONS = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


/**
 * This is a generic data call to api.  Support the following: GET, POST, PUT, PATCH, DELETE
 * get(url, [config]);
 delete(url, [config]);
 head(url, [config]);
 jsonp(url, [config]);
 post(url, data, [config]);
 put(url, data, [config]);
 patch(url, data, [config]);
 */

@Injectable()

export class ApiService {

  baseUrl: string;
  contextPath: string;
  constructor(private http: HttpClient, private router: Router) {

  }


  getEiaQueryString(
      action,
      params = null
  ){

    return this.getCall(
        this.buildUrl(this.baseUrl, action, null)
    )

  }

  getApiUrl(url){
    return this.getCall(url);
  }


  getEiaUrl(action, params, isJson:boolean = true){
    return this.getCall(this.buildUrl(this.baseUrl, action, params), null, isJson);
  }

  postEia(
      action,
      data = null
  ) {
    return this.postCall(
        this.buildUrl(this.baseUrl, action, null),
        data
    );
  }




  /**
   * Build url to be passed to api service class
   * @param base_url
   * @param action
   * @param nice_url_params
   * @returns {string}
   */
  private buildUrl(base_url, action, nice_url_params = null){
    //prepare nice url string

    let nice_url: string = '';
    //convert nice url array to string
    if (nice_url_params) {
      //Sample url/<array_value1>/<array_value2>/<array_value3>
      if (Array.isArray(nice_url_params)) {
        nice_url = '/' + nice_url_params.join('/');
      }else if (typeof nice_url_params === 'string' || nice_url_params instanceof String){
        nice_url = '/' + nice_url_params;
      }else if (typeof(nice_url_params) === 'object') {
        let params = [];
        for(let key in nice_url_params) {
          params.push(key + '=' + nice_url_params[key]);
        }

        nice_url = '?' + params.join('&');
      }
    }
    return base_url + '/' + action + nice_url;
  }




  /**
   * Get API
   * @param url
   * @param isExternal
   * @param withToken
   * @param params
   * @param extraCallParameters
   * @returns {*}
   */
  getCall(url, params = null, isJson: boolean = true, extraCallParameters = null, isExternal: boolean = false, withToken: boolean = true) {
    return this.apiCall(API_CALL_TYPE.GET, url, null, isExternal, withToken, params, isJson, extraCallParameters);
  }


  /**
   * DELETE API
   * @param url
   * @param isExternal
   * @param withToken
   * @returns {*}
   */
  deleteCall(url, isExternal: boolean = false, withToken: boolean = true) {
    return this.apiCall(API_CALL_TYPE.DELETE, url, null, isExternal, withToken);
  }

  /**
   * Post API
   * @param url
   * @param data
   * @param isExternal
   * @param withToken
   * @param isJson
   * @returns {*}
   */
  postCall(url, data, isExternal: boolean = false, withToken: boolean = true, isJson: boolean = false) {
    return this.apiCall(API_CALL_TYPE.POST, url, data, isExternal, withToken, null, isJson);
  }

  /**
   * PUT API
   * @param url
   * @param data
   * @param isExternal
   * @param withToken
   * @param isJson
   * @returns {*}
   */
  putCall(url, data, isExternal: boolean = false, withToken: boolean = true, isJson: boolean = false) {
    return this.apiCall(API_CALL_TYPE.PUT, url, data, isExternal, withToken, null, isJson);
  }



  /**
   * Patch API call
   * @param url
   * @param data
   * @param isExternal
   * @param withToken
   * @param isJson
   * @returns {*}
   */
  patchCall(url, data, isExternal: boolean = false, withToken: boolean = true, isJson: boolean = false) {
    return this.apiCall(API_CALL_TYPE.PATCH, url, data, isExternal, withToken, null, isJson);
  }

  /**
   * Generic api call
   * @param type
   * @param url
   * @param data
   * @param isExternal
   * @param withToken
   * @param params
   * @param isJson
   * @param extraCallParameters
   * @returns {any}
   */
  private apiCall(type, url, data, isExternal: boolean = false, withToken: boolean = true, params = null, isJson = false, extraCallParameters = null) {
    //if (!isExternal) {
    //url = this.baseUrl + this.contextPath + url;
    //}

    let return_call: any = null;
    let call: any = null;
    switch (type) {
      case API_CALL_TYPE.POST:
        call = this.http.post(url, data, this.getOptions(withToken, isJson));
        break;
      case API_CALL_TYPE.PUT:
        call = this.http.put(url, data, this.getOptions(withToken, isJson));
        break;
      case API_CALL_TYPE.PATCH:
        call = this.http.patch(url, data, this.getOptions(withToken, isJson));
        break;
      case API_CALL_TYPE.DELETE:
        call = this.http.delete(url, this.getOptions(withToken));
        break;
      case API_CALL_TYPE.GET:

        call = this.http.get(url, this.getOptions(withToken, isJson));
        break;
    }
    return call;
  }

  private getOptions(withToken: boolean = true, isJson: boolean = false, params = null, extraCallParameters = null) {
    let ret = {};
    if(!isJson) {
      ret['responseType'] = 'text';
    }
    return ret;
  }

  isArray(obj: any) {
    return Array.isArray(obj);
  }

  isObject(val) {
    if (val === null) {
      return false;
    }
    return ((typeof val === 'object') && !(Array.isArray(val)));
  }

  arraysIdentical(a, b) {
    let i = a.length;
    if (i !== b.length) {
      return false;
    }
    while (i--) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }

  objectsIdentical(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2) ;
  }

  copyObject(object: Object) {
    return JSON.parse(JSON.stringify(object));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts